import React, { useEffect, useState } from 'react'
import { StatusBar } from '@uppy/react'

const InprogressUploads = props => {
  const [initialized, setInitialized] = useState(false)
  const [numUploadsPending, setNumUploadsPending] = useState(0)
  const [numUploadsTotal, setNumUploadsTotal] = useState(0)
  const [visible, setVisible] = useState(true)
  const { getUppy } = props

  if (!initialized) {
    getUppy().on('upload-progress', (file, progress) => {
      const uppyFiles = getUppy().getState().files
      let pending = 0
      let total = 0
      Object.keys(uppyFiles).forEach(fileId => {
        total += 1
        if (uppyFiles[fileId].progress.percentage !== 100) {
          pending += 1
        }
      })
      if (pending !== numUploadsPending) {
        setNumUploadsPending(pending)
      }
      if (total !== numUploadsTotal) {
        setNumUploadsTotal(total)
      }
    })
    getUppy().on('complete', () => {
      getUppy().reset()
      setNumUploadsPending(0)
      setNumUploadsTotal(0)
      // reset visibility so the next upload in progress isn't hidden
      setVisible(true)
    })
    setInitialized(true)
  }

  let fileCountEl = null
  if (numUploadsPending && numUploadsTotal) {
    fileCountEl = `${numUploadsTotal - numUploadsPending} / ${numUploadsTotal}`
  }

  let hideButtonEl = null
  if (numUploadsPending && numUploadsTotal) {
    hideButtonEl = <button style={{padding: '0 3px'}} className="btn" onClick={() => setVisible(false)} >Hide</button>
  }

  if (!visible || !numUploadsPending || !numUploadsTotal) return null
  return (
    <div className="inprogress-uploads-wrapper">
      <div className="inprogress-uploads-info">
        {fileCountEl}
        {hideButtonEl}
      </div>
      <StatusBar
        id="inProgressStatusBar"
        uppy={getUppy()}
        hideUploadButton={true}
        hideAfterFinish={true}
        ShowProgressDetails={true}
        hidePauseResumeButton={true} // seems to fail the upload
        hideCancelButton={true}
      />
    </div>
  )
}

export default InprogressUploads
